import axios from './axios'

const requests = {
	// 查询活动
	getProduct(data = {}) {
		return axios('/biz/getProductByTypeName', {
			method: 'post',
			data: data
		})
	},
	// 查询活动内商家
	getShopByProduct(data = {}) {
		return axios('/biz/getShopByProduct', {
			method: 'post',
			data: data
		})
	},
	// 经纬度查询商家活动
	getProductByXY(data = {}) {
		return axios('/biz/getProductByXY', {
			method: 'post',
			data: data
		})
	},
	// 获取openid
	getOpenId(data = {}) {
		return axios('/biz/openId', {
			method: 'post',
			data: data
		})
	},
	// 获取链接地址
	getOrderUrl(data = {}) {
		return axios('/biz/getOrderUrl', {
			method: 'post',
			data: data
		})
	},
	// 获取菜单
	getBizMenuList(data = {}) {
		return axios('/biz/getBizMenuList', {
			method: 'post',
			data: data
		})
	},
	// 获取活动
	getQueryProduct(data = {}) {
		return axios('/biz/queryProduct', {
			method: 'post',
			data: data
		})
	},
	// 获取微信参数
	getWxSignature(data = {}) {
		return axios('/biz/getWxSignature', {
			method: 'post',
			data: data
		})
	},
	// 获取渠道信息
	getActivity(data = {}) {
		return axios('/biz/getActivity', {
			method: 'post',
			data: data
		})
	},
	// 获取电商
	getDSProduct(data = {}) {
		return axios('/biz/getDSProduct', {
			method: 'post',
			data: data
		})
	},

	// // 示例
	// getNextPlay(data = {}){
	//   return axios('/fmChapter/playUrl',{
	//     method: 'post',
	//     data: data
	//   })
	// },



}
// 导出对象，然后在全局注册或在单个vue文件下调用
export default requests
